import { connect } from 'react-redux';

import ControlsMenu from 'components/advanced/ControlsMenu';
import { getTurbineParams } from "selectors/turbineParams";
import { getLiveParams } from 'selectors/liveParams';

// windTurbine can be momentarily undefined during navigation between two
// turbines' detail pages - see components/dashboard/CardHeader.js's guard
// for the crash this caused. mapStateToProps runs on every store update.
const mapStateToProps = (state, ownProps) => {
  const windTurbineId = ownProps.windTurbine && ownProps.windTurbine.id;
  return {
    turbineParams: getTurbineParams(state, windTurbineId),
    liveParams: getLiveParams(state, windTurbineId, "all"),
  };
};

export default connect(mapStateToProps)(ControlsMenu);
